/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileModel } from './FileModel';
export type RequestedFile = {
  readonly id?: number;
  name: string;
  is_uploaded?: boolean;
  company_information_request_status?: number | null;
  files: Array<FileModel>;
  folder?: number | null;
  reference_object_type?: RequestedFile.reference_object_type | null;
  reference_object_id?: number | null;
};
export namespace RequestedFile {
  export enum reference_object_type {
    CT = 'ct',
    FI = 'fi',
    FO = 'fo',
    CB = 'cb',
    EV = 'ev',
    SSV = 'ssv',
    MA = 'ma',
    FIO = 'fio',
    RS = 'rs',
  }
}

